import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.doctorVideoUrl
    ? _c(
        VApp,
        { attrs: { "data-video-card": "" } },
        [
          _c(
            VSheet,
            {
              staticClass: "rounded-pill overflow-hidden cursor-pointer",
              attrs: { "data-qa": "doctor_video_card_play_color" },
            },
            [
              _c(VImg, {
                directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                attrs: {
                  alt: _vm.$t("Открыть видеовизитку", {
                    ns: _vm.$i18next.language,
                  }),
                  width: "32",
                  height: "32",
                  src: "/static/_v1/pd/icons/ui-kit/video-card-play.svg",
                },
                on: { click: _vm.handleOpenDialog },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                VDialog,
                {
                  attrs: {
                    "data-qa": "doctor_video_card_dialog",
                    fullscreen: "",
                    divider: "",
                  },
                  model: {
                    value: _vm.isDialogVisible,
                    callback: function ($$v) {
                      _vm.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "video-card-wrapper text",
                      attrs: { "data-qa": "doctor_video_card_dialog" },
                    },
                    [
                      _c("div", {
                        staticClass:
                          "video-card-player-close ui-icon_reset bg-gray-0--text ui-icon-close-not-a-circle",
                        on: {
                          click: function ($event) {
                            _vm.isDialogVisible = false
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "video-card-switch-state",
                        on: { click: _vm.videoSwitchState },
                      }),
                      _vm._v(" "),
                      !_vm.isVideoPlaying
                        ? _c("div", { staticClass: "video-card-play" }, [
                            _c("div", {
                              staticClass:
                                "ui-icon_reset primary--text ui-icon-player-play",
                            }),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.videoTimeTotal && _vm.videoTimeCurrent
                        ? _c("div", { staticClass: "video-card-time-cover" }, [
                            _c("div", { staticClass: "video-card-time" }, [
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-0--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.videoTimeCurrent) +
                                      "\n          "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-body-1 bg-gray-60--text px-1",
                                },
                                [_vm._v("/")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-body-1 bg-gray-60--text" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.videoTimeTotal) +
                                      "\n          "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("video", {
                        ref: "video",
                        staticClass: "video-card-player",
                        attrs: { playsinline: "", src: _vm.doctorVideoUrl },
                        on: {
                          ended: _vm.handleEnded,
                          timeupdate: _vm.handleTimeupdate,
                          loadedmetadata: _vm.handleLoadedmetadata,
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _c(
                "CoreDialog",
                {
                  attrs: {
                    "data-qa": "doctor_video_card_dialog",
                    size: "lg",
                    title: _vm.$t("Видеовизитка", {
                      ns: _vm.$i18next.language,
                    }),
                    divider: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "prependBtn",
                        fn: function ({ btnProps }) {
                          return [
                            _c(
                              VBtn,
                              _vm._b(
                                {
                                  on: {
                                    click: function ($event) {
                                      _vm.isDialogVisible = false
                                    },
                                  },
                                },
                                "v-btn",
                                btnProps,
                                false
                              ),
                              [
                                _c("span", {
                                  staticClass: "ui-icon-close-not-a-circle",
                                }),
                              ]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1322088010
                  ),
                  model: {
                    value: _vm.isDialogVisible,
                    callback: function ($$v) {
                      _vm.isDialogVisible = $$v
                    },
                    expression: "isDialogVisible",
                  },
                },
                [
                  _vm._v(" "),
                  _c("video", {
                    ref: "video",
                    staticClass: "video-card-player",
                    attrs: { controls: "", src: _vm.doctorVideoUrl },
                    on: { ended: _vm.handleEnded },
                  }),
                ]
              ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }